import { Anchor, Box, Container, Group, Text } from "@mantine/core";
import { useTranslation } from "../hooks/translation-hook";
import { useToolkitLinks } from "../hooks/links-hook";

export function SiteHeader(): JSX.Element {
  const translate = useTranslation();
  const headerLinks = useToolkitLinks("nav");

  return (
    <Box
      component="header"
      bg="#f3f3f3"
      style={{ borderBottom: "1px solid #e3e3e3" }}
    >
      <Container size="xl">
        <Group justify="space-between" align="center" h={44} wrap="nowrap">
          <Text c="#666" size="sm" style={{ letterSpacing: "0.01em" }}>
            Toolkit
          </Text>

          <Group gap={22} align="center" wrap="nowrap">
            <Group gap={22} visibleFrom="sm" wrap="nowrap">
              {headerLinks.map((link) => (
                <Anchor
                  key={`${link.name}-${link.url}`}
                  href={link.url}
                  c="#474747"
                  size="sm"
                  fw={400}
                  style={{ textDecoration: "none" }}
                >
                  {translate(link.name, "toolkit")}
                </Anchor>
              ))}
            </Group>
          </Group>
        </Group>

        <Box
          h={{ base: 70, md: 80 }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box component="a" href="#" style={{ textDecoration: "none", lineHeight: 1 }}>
            <Text
              c="#000"
              style={{
                fontFamily: "DINPro, sans-serif",
                fontSize: "2rem",
                fontWeight: 700,
              }}
            >
              Panasonic
            </Text>
          </Box>
        </Box>
      </Container >
    </Box >
  );
}
